module.exports = __webpack_public_path__ + "img/457.4a22cd67.png";